import PropTypes from 'prop-types';
import clsx from 'clsx';
import { FormControlLabel, Radio, RadioGroup, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { FaChevronDown } from 'react-icons/fa';
import { useAnalytics } from 'use-analytics';
import AddCardForm from '../../../../../CruiseBooking/PaymentConfig/AddCardForm';
import SavedCards from '../../../../../CruiseBooking/PaymentConfig/SavedCards';
import { changeTrip } from '../../../../../../store/slices/trip';
import { PaymentModes } from '../../../../../../constants';
import { useCallback } from 'react';

const useStyles = makeStyles(() => ({
  label: {
    fontSize: '0.75rem',
  },
}));
const useStylesRadioGroup = makeStyles(() => ({
  root: {
    '& .MuiFormControlLabel-label': {
      fontFamily: 'var(--fontFamilyBody)',
    },
  },
}));

const CardSelectForm = ({ tripId, doShowCardForm, onCardFormShown }) => {
  const { track } = useAnalytics();
  const classes = useStyles();
  const classesRadioGroup = useStylesRadioGroup();
  const dispatch = useDispatch();
  const { travelAgency, email: loggedInUserEmail } = useSelector((store) => store.user);
  const paymentMethods = useSelector((store) => store.trip.paymentMethods);
  const cardIndex = 0;
  const paymentMethod = paymentMethods && paymentMethods[cardIndex];

  const handleChange = useCallback(
    (fieldName, value) => {
      if (value) {
        dispatch(
          changeTrip({
            field: 'paymentMethods',
            value: {
              ...paymentMethods,
              [cardIndex]: {
                ...paymentMethod,
                [fieldName]: value,
              },
            },
          }),
        );
      }
    },
    [paymentMethods, paymentMethod, dispatch],
  );

  const handleChangeCardSelection = (event) => {
    handleChange('paymentMode', event.target.value);
    track('CardSelectForm.ChangeCardSelection', {
      doUseSavedCard: event.target.value === PaymentModes.SAVED_CARD,
      paymentMode: event.target.value,
      cardIndex: 0,
      tripId,
      loggedInUserEmail,
    });
  };

  const handleShowCardForm = () => {
    if (onCardFormShown) {
      onCardFormShown(!doShowCardForm);
    }
  };

  return (
    <div className="text-xs">
      {!doShowCardForm && (
        <>
          <button
            type="button"
            className="mt-2 underline text-theme ml-1"
            onClick={handleShowCardForm}
          >
            Select credit card
            <FaChevronDown className="inline-block ml-1" />
          </button>
          <div className="text-gray-600 ml-1">
            If you do not select a card, the default credit card from{' '}
            {travelAgency.sabreProfileName} profile will be utilized for the booking.
          </div>
        </>
      )}
      {doShowCardForm && (
        <div className={clsx({ 'border border-gray-400 rounded p-2 mt-2': doShowCardForm })}>
          <div>
            <div className="w-95 mx-auto">
              <div className="font-bold">Credit card</div>
              <div className="text-grey-700">
                Select credit card to use for booking trip quote. MasterCard, Visa, Amex, Diners
                Club, JCB, Discover
              </div>
              <RadioGroup
                aria-label="changeCardSelection"
                name="changeCardSelection"
                classes={classesRadioGroup}
                value={paymentMethod?.paymentMode}
                onChange={handleChangeCardSelection}
                row
              >
                <FormControlLabel
                  value={PaymentModes.NEW_CREDIT_CARD}
                  classes={classes}
                  control={<Radio />}
                  label="New card"
                />
                <FormControlLabel
                  classes={classes}
                  value={PaymentModes.SAVED_CARD}
                  control={<Radio />}
                  label="Saved cards"
                />
              </RadioGroup>

              {paymentMethod?.paymentMode === PaymentModes.NEW_CREDIT_CARD && (
                <AddCardForm
                  cardIndex={0}
                  doShowSecurityCodeInput={false}
                  doTakeCardAddressInputs={false}
                  widthClass=""
                  inputLayout={AddCardForm.InputLayoutTypes.ROW}
                  useVGSInputForm={true}
                />
              )}

              {paymentMethod?.paymentMode === PaymentModes.SAVED_CARD && (
                <SavedCards tripId={tripId} paymentMethodIndex={0} />
              )}

              <div className="text-right">
                <button type="button" onClick={handleShowCardForm}>
                  Don&apos;t include card
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

CardSelectForm.propTypes = {
  tripId: PropTypes.string.isRequired,
  doShowCardForm: PropTypes.bool.isRequired,
  onCardFormShown: PropTypes.func,
};

CardSelectForm.defaultProps = {
  onCardFormShown: undefined,
};
export default CardSelectForm;
